<template>
  <div v-if="visible && ad" class="float-ad">
    <div class="float-ad-content">
      <div class="ad-image" @click="handleAdClick">
        <img :src="ad.adImage" :alt="ad.adTitle">
      </div>
      <div class="ad-close" @click.stop="close">
        <i class="el-icon-close"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { addAdvertisementView } from '@/api/courseApi'

export default {
  name: 'AdFloat',
  props: {
    ad: {
      type: Object,
      required: true
    },
    pageId: {
      type: String,
      default: 'home'
    }
  },
  data() {
    return {
      visible: false
    }
  },
  watch: {
    ad: {
      handler(newVal) {
        if (newVal) {
          this.checkVisible()
        }
      },
      immediate: true
    }
  },
  methods: {
    checkVisible() {
      const key = `ad_float_closed_${this.pageId}`
      const closed = sessionStorage.getItem(key)
      this.visible = !closed
    },
    handleAdClick() {
      if (!this.ad) return
      
      if (this.ad.id) {
        addAdvertisementView(this.ad.id).catch(e => console.error(e))
      }
      
      const url = this.sanitizeUrl(this.ad.adLink)
      if (url) {
        window.open(url, '_blank', 'noopener')
      }
    },
    close() {
      this.visible = false
      const key = `ad_float_closed_${this.pageId}`
      sessionStorage.setItem(key, 'true')
    },
    sanitizeUrl(url) {
      const raw = String(url || '').trim()
      if (!raw) return ''
      return raw.replace(/`/g, '').trim()
    }
  }
}
</script>

<style scoped>
.float-ad {
  position: fixed;
  right: 20px;
  bottom: 100px;
  z-index: 2000;
}
.float-ad-content {
  position: relative;
  width: 120px;
  cursor: pointer;
}
.float-ad-content img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}
.ad-close {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
  background: rgba(0,0,0,0.5);
  color: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  cursor: pointer;
}
</style>
